module.exports = __webpack_public_path__ + "img/testovany.fb43b8ca.png";